import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/css';

const sliders = {
  init() {
    this.prodSlider();
    this.showcaseSlider();
    this.textSlider();
    this.socialSlider();
    this.heroSlider();
    this.gallerySlider();
    this.setProdThumbnailsSlider();
    this.setProdThumbnailsGallerySlider();
    this.resetSlider();
  },

  resetSlider() {
    window.addEventListener('reset', () => {
      this.setProdThumbnailsSlider();
      this.setProdThumbnailsGallerySlider();
    });
  },

  showcaseSlider() {
    const sliders = document.querySelectorAll(
      '.jsShowcaseSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: true,
        arrows: false,
        gap: 0,
        perPage: 1,
        padding: { right: '10%' },
        destroy: true,
        breakpoints: {
          1200: {
            destroy: false,
          },
        },
      }).mount();
    });
  },

  heroSlider() {
    const sliders = document.querySelectorAll(
      '.jsHeroSlider',
    ) as NodeListOf<HTMLElement>;
    sliders.forEach((el) => {
      const slider = new Splide(el, {
        type: 'fade',
        perPage: 1,
        pagination: true,
        arrows: false,
        autoplay: true,
        speed: 800,
      });

      slider.mount();
    });
  },

  socialSlider() {
    const sliders = document.querySelectorAll(
      '.jsSocialSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: true,
        gap: 20,
        perPage: 4,
        perMove: 1,
        padding: { right: '10%' },
        breakpoints: {
          1200: {
            perPage: 2,
          },
          768: {
            perPage: 1,
          },
        },
      }).mount();
    });
  },

  prodSlider() {
    const sliders = document.querySelectorAll(
      '.jsProdSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'slide',
        pagination: true,
        arrows: false,
        autoplay: true,
        speed: 800,
        rewind: true,
        rewindByDrag: true,
        gap: 20,
        perPage: 4,
        perMove: 1,
        padding: { right: '30%' },
        breakpoints: {
          1400: {
            perPage: 3,
          },
          1200: {
            perPage: 2,
            arrows: true,
          },
          767: {
            perPage: 1,
            arrows: true,
          },
        },
      }).mount();
    });
  },

  gallerySlider() {
    const sliders = document.querySelectorAll(
      '.jsGallerySlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'carousel',
        pagination: true,
        arrows: true,
        autoplay: true,
        speed: 800,
        gap: 25,
        perPage: 4,
        rewind: true,
        perMove: 1,
        breakpoints: {
          1200: {
            perPage: 2,
            arrows: true,
          },
          767: {
            perPage: 1,
            arrows: true,
          },
        },
      }).mount();
    });
  },

  textSlider() {
    const sliders = document.querySelectorAll(
      '.jsTextSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        perPage: 4,
        pagination: false,
        arrows: false,
        gap: 30,
        autoScroll: {
          speed: -1,
        },
        breakpoints: {
          768: {
            perPage: 3,
            gap: 15,
          },
          500: {
            perPage: 1,
            padding: { right: '30%' },
          },
        },
      }).mount({ AutoScroll });
    });
  },

  setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById('mainImage') as
      | HTMLElement
      | undefined;
    const thumbnails = document.getElementById('thumbnails') as
      | HTMLElement
      | undefined;

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false,
        breakpoints: {
          1200: {
            arrows: false,
            pagination: true,
          },
        },
      });

      const thumbnailsNav = new Splide(thumbnails, {
        direction: 'ltr',
        isNavigation: true,
        pagination: false,
        perPage: 5,
        perMove: 1,
        arrows: false,
        gap: '30px',
        breakpoints: {
          1500: {
            perPage: 3,
          },
        },
      });

      main.sync(thumbnailsNav);
      main.mount();
      thumbnailsNav.mount();
    }
  },

    setProdThumbnailsGallerySlider() {
    const porductMainImages = document.getElementById('mainImageGallery') as
      | HTMLElement
      | undefined;


    if (porductMainImages ) {
      const main = new Splide(porductMainImages, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
        breakpoints: {
          1200: {
            arrows: false,
            pagination: false,
          },
        },
      });


      main.mount();
  
    }
  },
};

export default sliders;
